/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
!function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.zoom=function(t,n,e,i){var u,c,a,r,m,l,s,f=o(t),h=f.css("position"),d=o(n);return t.style.position=/(absolute|fixed)/.test(h)?h:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=f.outerWidth(),u=f.outerHeight(),n===t?(r=c,a=u):(r=d.outerWidth(),a=d.outerHeight()),m=(e.width-c)/r,l=(e.height-u)/a,s=d.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,a),0),t=Math.max(Math.min(t,r),0),e.style.left=t*-m+"px",e.style.top=n*-l+"px"}}},o.fn.zoom=function(n){return this.each(function(){var e=o.extend({},t,n||{}),i=e.target&&o(e.target)[0]||this,u=this,c=o(u),a=document.createElement("img"),r=o(a),m="mousemove.zoom",l=!1,s=!1;if(!e.url){var f=u.querySelector("img");if(f&&(e.url=f.getAttribute("data-src")||f.currentSrc||f.src),!e.url)return}c.one("zoom.destroy",function(o,t){c.off(".zoom"),i.style.position=o,i.style.overflow=t,a.onload=null,r.remove()}.bind(this,i.style.position,i.style.overflow)),a.onload=function(){function t(t){f.init(),f.move(t),r.stop().fadeTo(o.support.opacity?e.duration:0,1,!!o.isFunction(e.onZoomIn)&&e.onZoomIn.call(a))}function n(){r.stop().fadeTo(e.duration,0,!!o.isFunction(e.onZoomOut)&&e.onZoomOut.call(a))}var f=o.zoom(i,u,a,e.magnify);"grab"===e.on?c.on("mousedown.zoom",function(e){1===e.which&&(o(document).one("mouseup.zoom",function(){n(),o(document).off(m,f.move)}),t(e),o(document).on(m,f.move),e.preventDefault())}):"click"===e.on?c.on("click.zoom",function(e){return l?void 0:(l=!0,t(e),o(document).on(m,f.move),o(document).one("click.zoom",function(){n(),l=!1,o(document).off(m,f.move)}),!1)}):"toggle"===e.on?c.on("click.zoom",function(o){l?n():t(o),l=!l}):"mouseover"===e.on&&(f.init(),c.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(m,f.move)),e.touch&&c.on("touchstart.zoom",function(o){o.preventDefault(),s?(s=!1,n()):(s=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(o){o.preventDefault(),f.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}).on("touchend.zoom",function(o){o.preventDefault(),s&&(s=!1,n())}),o.isFunction(e.callback)&&e.callback.call(a)},a.setAttribute("role","presentation"),a.alt="",a.src=e.url})},o.fn.zoom.defaults=t}(window.jQuery);


window.REBASE = window.REBASE || {};
REBASE.theme = REBASE.theme || {};

(function($) {
  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Main Script
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/
  document.addEventListener('DOMContentLoaded', function() {
    REBASE.theme.bindProductControls();
  });

  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Setup Product page controls (needs to run on product pages and when quickview is opened)
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/
  REBASE.theme.bindProductControls = function() {
    var product, photo_gallery;

    document.dispatchEvent(new Event('REBASE:bindProductControls'));

    // Option Selectors & Swatches
    // NOTE: must come after image gallery (for selected variant to show correct image when loading page)
    product = new REBASE.theme.Product({
      $container: $('#minicart-add-to-cart-form')
    });

    // Add to cart sections
    $('.add-item-section__toggle--add-on').on('click.rbProduct', function (e) {
      e.preventDefault();
      $('.fa', this).toggleClass('fa-square-o fa-check-square');
      $(this).toggleClass('add-item-section__toggle--active').parent().toggleClass('extra-product--selected');

      if (typeof calculateExtraPrice === 'function') {
        calculateExtraPrice();
      }
    });
  };

  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Product class
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/

  REBASE.theme.Product = (function() {
    function Product(options) {
      var inputs, input_type;

      this.variants = null;
      this.$container = options.$container;
      this.data = JSON.parse(document.getElementById('product__json').innerHTML);

      this.settings = {
        single_option_selector: '.single-option-select',
        original_select_id: 'select#product-select'
      };

      if (this.data) {
        this._initVariants();

        // Trigger change to sync up images, etc on initial page load
        inputs = $(this.settings.single_option_selector, this.$container);
        input_type = inputs.first().attr('type');

        if(!document.body.classList.contains('bundle-product')) {
          if (input_type === 'radio' || input_type === 'checkbox') {
            inputs.filter(':checked:first').trigger('change');
          } else {
            inputs.first().trigger('change');
          }
        }
      } else {
        if (console) {
          console.log('Missing product json data!');
        }
      }
    }

    Product.prototype = $.extend({}, Product.prototype, {
      _initVariants: function() {
        var options = {
          $container: this.$container,
          enable_history_state: true,
          single_option_selector: this.settings.single_option_selector,
          original_select_id: this.settings.original_select_id,
          product: this.data
        };

        this.variants = new REBASE.theme.Variants(options);
        this.$container.on('variantChange', this._updateAddToCart.bind(this));
      },
      _updateAddToCart: function(e) {
        var variant = e.variant,
          all_variants_match_option1 = e.all_variants_match_option1,
          target = $(e.target),
          input_type = target.attr('type'),
          add_to_cart_btn = $('#add-to-cart'),
          btn_txt = $('#add-to-cart-text'),
          btn_txt_value = btn_txt.data('add-to-cart-text'),
          tn_add_to_cart_btn = $('#tn-add-to-cart'),
          tn_btn_txt = $('#tn-add-to-cart-text'),
          tn_btn_txt_value = tn_btn_txt.data('add-to-cart-text'),
          tn_info_pdp = $('#tn-info-pdp'),
          preorder = $('.product__preorderMessage');

        if (variant.inventory_policy && variant.inventory_policy === 'continue') {
          add_to_cart_btn.addClass('disabled-continue');
        }

        if (!variant) {
          add_to_cart_btn.addClass('disabled').attr('disabled', 'disabled');
          btn_txt.text('Not Available');
          $('.product-pricing').removeClass('product--on-sale');
          $('.product-pricing .product-price').html('<span>Not Available</span>');
          $('.product-pricing .old-price').empty();
          tn_add_to_cart_btn.addClass('disabled').attr('disabled', 'disabled');
          tn_add_to_cart_btn.addClass('tn-hidden');
          tn_info_pdp.addClass('tn-hidden');

          if(window.is_preorder) {
            preorder.addClass('hidden');
          }
        } else {
          if (window.is_preorder) {
            if (variant.inventory_quantity === 0) {
              preorder.removeClass('hidden');
            } else {
              preorder.addClass('hidden');
            }
          }

          if (variant.available) {
            add_to_cart_btn
              .removeClass('disabled')
              .removeAttr('disabled')
              .show();
            btn_txt.text(btn_txt_value);
            tn_add_to_cart_btn
              .removeClass('disabled')
              .removeAttr('disabled')
              .removeClass('tn-hidden')
              .show();
            tn_info_pdp.removeClass('tn-hidden');
            tn_btn_txt.text(tn_btn_txt_value);
          } else {
            add_to_cart_btn
              .addClass('disabled')
              .attr('disabled', 'disabled');
            tn_add_to_cart_btn
              .addClass('disabled')
              .attr('disabled', 'disabled')
              .addClass('tn-hidden');
            tn_info_pdp.addClass('tn-hidden');
            if (add_to_cart_btn.hasClass('vintage')) {
              btn_txt.text('Not Available');
              tn_add_to_cart_btn.addClass('tn-hidden');
              tn_info_pdp.addClass('tn-hidden');
            } else {
              btn_txt.text('SOLD OUT');
              tn_add_to_cart_btn.addClass('tn-hidden');
              tn_info_pdp.addClass('tn-hidden');
            }
          }
        }

        if (input_type === 'radio' || input_type === 'checkbox') {
          localStorage.setItem('selectedVariant', e.target.value);

          // MODDED FOR SWATCH AVAILABILITY (only one level deep, option2)
          var option2_inputs = $('input[data-index="option2"]'),
            option2_vals = option2_inputs
            .map(function() {
              return $(this).val();
            })
            .get(),
            option2_not_available = $.map(option2_vals, function(option_val) {
              var is_available = false;

              $.each(all_variants_match_option1, function(i, match_variant) {
                if (match_variant.option2 === option_val) {
                  if (match_variant.available) {
                    is_available = true;
                  }
                }
              });

              if (is_available) {
                return undefined;
              } else {
                return option_val;
              }
            });

          option2_inputs.parent('.swatch-element').removeClass('swatch-unavailable');

          $.each(option2_not_available, function(indx, option_val) {
            option2_inputs.each(function() {
              var current_option_input = $(this);

              if (current_option_input.val() === option_val) {
                current_option_input.parent('.swatch-element').addClass('swatch-unavailable');
              }
            });
          });
        }
      },
    });

    return Product;
  })();

  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Product Variants class - based on Shopify debut
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/

  REBASE.theme.Variants = (function() {
    function Variants(options) {
      this.$container = options.$container;
      this.product = options.product;
      this.single_option_selector = options.single_option_selector;
      this.original_select_id = options.original_select_id;
      this.enable_history_state = options.enable_history_state;
      this.current_variant = {};
      let isActiveVariant = false;

      $(this.single_option_selector, this.$container).on('change', this._onSelectChange.bind(this));

      this.product.variants.forEach(variant => {
        const lacesVariant = document.querySelectorAll(`.product__variantsSwatchesList [data-variant="${variant.option1}"]`);

        if (!variant.available || variant.inventory_quantity <= 0) {
          const disabledVariantLabel = document.querySelector(`.product__swatchesItemLabel[data-option="${variant.option1}"]`);

          if (disabledVariantLabel && variant.inventory_policy != 'continue' && variant.inventory_management != null) {
            disabledVariantLabel.classList.add('product__swatchesItemLabel--disabled');

            lacesVariant.forEach((variant) => {
              variant.classList.add('product__variantsSwatchesListItems--disabled');
            });
          }
        }
      });

      const activeSwatches = document.querySelectorAll('.product__variantsSwatchesListItems--active');

      if (activeSwatches.length === 2) {
        activeSwatches[0].click();
      }
    }

    Variants.prototype = $.extend({}, Variants.prototype, {
      /**
       * Get the currently selected options from add-to-cart form. Works with all
       * form input elements.
       *
       * @return {array} options - Values of currently selected variants
       */
      _getCurrentOptions: function() {
        var should_filter = false,
          the_options = $.map($(this.single_option_selector, this.$container), function(element) {
            var $element = $(element),
              type = $element.attr('type'),
              current_option = {};

            if (type === 'radio' || type === 'checkbox') {
              should_filter = true;

              if ($element[0].checked) {
                current_option.value = $element.val();
                current_option.index = $element.data('index');
                return current_option;
              } else {
                return false;
              }
            } else {
              current_option.value = $element.val();
              current_option.index = $element.data('index');
              return current_option;
            }
          });

        // Remove any unchecked input values if using radio buttons or checkboxes
        // Removes all falsy values (Boolean varructor is a function, if the value is omitted or is 0, -0, null, false, NaN, undefined, or the empty string ("") then it will get removed)
        if (should_filter) {
          the_options = the_options.filter(Boolean);
        }

        return the_options;
      },

      /**
       * Find variant based on selected values.
       *
       * @param  {array} selected_values - Values of variant inputs
       * @return {object || undefined} found - Variant object from product.variants
       */
      _getVariantFromOptions: function() {
        var selected_values = this._getCurrentOptions(),
          variants = this.product.variants,
          all_variants_match_option1,
          found;

        found = $.grep(variants, function(variant) {
          return selected_values.every(function(values) {
            return variant[values.index] === values.value;
          });
        });

        all_variants_match_option1 = $.grep(variants, function(variant) {
          return variant[selected_values[0].index] === selected_values[0].value;
        });

        if (found.length) {
          found = found[0];
        } else {
          found = undefined;
        }

        return {
          variant_match: found,
          all_variants_match_option1: all_variants_match_option1
        };
      },

      /**
       * Event handler for when a variant input changes.
       */
      _onSelectChange: function(e) {
        var variant_from_options = this._getVariantFromOptions(),
          variant;

        variant = variant_from_options.variant_match

        this.$container.trigger({
          type: 'variantChange',
          variant: variant,
          all_variants_match_option1: variant_from_options.all_variants_match_option1,
          target: e.target
        });

        if (!variant) {
          this.current_variant = {};
          return;
        }

        this._updateMasterSelect(variant);
        this.current_variant = variant;

        if (this.enable_history_state) {
          this._updateHistoryState(variant);
        }

        $('.product__buttons button').attr("data-inventory-quantity", this.current_variant.inventory_quantity);
        $('.product__buttons button').attr("data-id", this.current_variant.id);

        //Left in stock change on variant change
        if (variant.inventory_quantity < 5 && variant.inventory_quantity > 0) {
          $('.left-in-stock').addClass('left-in-stock--visible');
          $('.left-in-stock').children('span').html(variant.inventory_quantity);
        } else {
          $('.left-in-stock').removeClass('left-in-stock--visible');
        }
      },

      /**
       * Update history state for product deeplinking
       *
       * @param  {variant} variant - Currently selected variant
       * @return {k}         [description]
       */
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {return;}
        var urlParams = new URLSearchParams(window.location.search);
        urlParams.set('variant', variant.id);
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + urlParams.toString();
        window.history.replaceState({ path: newurl }, '', newurl);
      },

      /**
       * Update hidden master select of variant change
       *
       * @param  {variant} variant - Currently selected variant
       */
      _updateMasterSelect: function(variant) {
        $(this.original_select_id, this.$container).val(variant.id);
      }
    });

    return Variants;
  })();
})(jQuery);
